import React from "react";
import Breathes from "../../assets/icons/A Home That Breathes-01.png";
import Contemporary from "../../assets/icons/Contemporary Design-03-01.png";
import ModernLiving from "../../assets/icons/Fully Curated for Modern Living-01.png";
import Quality from "../../assets/icons/Future-Proof Quality & Trust-01.png";
import gridImage1 from "../../assets/images/au-1.jpg";
import gridImage2 from "../../assets/images/clubhouse.jpg";
import gridImage3 from "../../assets/images/au-3.jpg";
import gridImage4 from "../../assets/images/au-4.jpg";

export default function WhyAura() {
  return (
    <div id="about">
      <section className="bg-[#fdf6f6] py-7 xl:py-16 text-[#000] overflow-hidden">
        <div className="max-w-screen-xl mx-auto px-6">
          <div className="text-center mb-4 xl:mb-7 mx-auto leading-snug px-6">
            <h2 className="font-crimson text-3xl xl:text-5xl text-[#5e3920] pb-7">
              Lifestyle Amenities Designed for Modern Community Living
            </h2>
            <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 xl:text-[18px] font-inter leading-relaxed">
           Aura brings together spaces and features planned around modern family life, combining community, comfort, design and everyday convenience.
          </p>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-7">
            <div className="bg-[#F7DED0] border border-[#fff] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="bg-[#fdf6f6] w-20 h-20 flex justify-center items-center rounded-xl mb-4 p-2">
                <img
                  src={ModernLiving}
                  alt="An 7,000 Sq. Ft. Clubhouse"
                  className="w-auto h-auto"
                />
              </div>
              <p className="text-[24px] font-inter mb-2 text-[#5e3920]">
                Fully Curated for Modern Living
              </p>
              <p className="text-[#000000d9] mb-5 leading-relaxed font-inter">
               From co-working lounges to wellness zones, the project brings together spaces planned around modern lifestyle needs.
              </p>
              <img
                src={gridImage2}
                alt="An 7,000 Sq. Ft. Clubhouse "
                className="w-full h-64 rounded-lg object-cover"
              />
            </div>

            <div className="bg-[#F7DED0] border border-[#fff] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="bg-[#fdf6f6] w-20 h-20 flex justify-center items-center rounded-xl mb-4 p-2">
                <img
                  src={Contemporary}
                  alt="gated community in Patancheru"
                  className="w-auto h-auto"
                />
              </div>
              <p className="text-[24px] font-inter mb-2 text-[#5e3920]">
                Contemporary Design, Timeless Comfort
              </p>
              <p className="text-[#000000d9] mb-5 leading-relaxed font-inter">
                Minimalist aesthetics, premium finishes and smart layouts are designed to enhance both form and function.
              </p>
              <img
                src={gridImage3}
                alt="gated community in Patancheru"
                className="w-full h-64 rounded-lg object-cover"
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-7 mt-7">
            <div className="bg-[#F7DED0] border border-[#fff] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="bg-[#fdf6f6] w-20 h-20 flex justify-center items-center rounded-xl mb-4 p-2">
                <img
                  src={Breathes}
                  alt="apartments in Patancheru"
                  className="w-auto h-auto"
                />
              </div>
              <p className="text-[24px] font-inter mb-2 text-[#5e3920]">
                A Home That Breathes
              </p>
              <p className="text-[#000000d9] mb-5 leading-relaxed font-inter">
               Thoughtfully designed open spaces, landscaped gardens and natural light help create homes that feel connected with nature.
              </p>
              <img
                src={gridImage1}
                alt="apartments in Patancheru"
                className="w-full h-64 rounded-lg object-cover"
              />
            </div>

            {/* --- Card 4 --- */}
            <div className="bg-[#F7DED0] border border-[#fff] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="bg-[#fdf6f6] w-20 h-20 flex justify-center items-center rounded-xl mb-4 p-2">
                <img
                  src={Quality}
                  alt="best gated community apartments in Patancheru"
                  className="w-auto h-auto"
                />
              </div>
              <p className="text-[24px] font-inter mb-2 text-[#5e3920]">
                Future-Proof Quality & Trust
              </p>
              <p className="text-[#000000d9] mb-5 leading-relaxed font-inter">
                The project is built with trusted brands, certified materials and strict quality control, with a focus on long-term peace of mind.
              </p>
              <img
                src={gridImage4}
                alt="best gated community apartments in Patancheru"
                className="w-full h-64 rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
